import ZipFilesWorker from './zipFiles.worker.js';

const zipFilesWorker = typeof window === 'object' && new ZipFilesWorker();

export default zipFilesWorker;
